import script from "./TDCurrencyDot.vue?vue&type=script&setup=true&lang=js"
export * from "./TDCurrencyDot.vue?vue&type=script&setup=true&lang=js"

import "./TDCurrencyDot.vue?vue&type=style&index=0&id=50e8b524&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e8b524"]])

export default __exports__